import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { UtilsService } from '../../shared/core/utils.service';

@Component({
  selector: 'rl-dialog-window',
  templateUrl: './dialog-window.component.html',
  styleUrls: ['./dialog-window.component.scss']
})
export class DialogWindowComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() title;
  @Input() buttonsVisibility? : any = {};
  @Input() validate? = () => true;

  @Output() onCancel? : EventEmitter<void> = new EventEmitter<void>();
  @Output() onClose? : EventEmitter<void> = new EventEmitter<void>();
  @Output() onConfirm? : EventEmitter<void> = new EventEmitter<void>();
  @Output() onSave? : EventEmitter<void> = new EventEmitter<void>();
 
  @ViewChild(TemplateRef) dialog;

  buttons : any = {};
  
  constructor(private modal : BsModalService, private utils : UtilsService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.buttonsVisibility && !changes.buttonsVisibility.firstChange){
      for(let button in changes.buttonsVisibility.currentValue){
        if(changes.buttonsVisibility.previousValue[button] != changes.buttonsVisibility.currentValue[button]){
          this.updateButtonVisibility(button);
        }
      }
    }
  }

  ngOnInit(): void {
    this.utils.foreachOutput(this).subscribe(output => {
      this.updateButtonVisibility(output);
    });
  } 

  updateButtonVisibility(output : string) : void {
    this.buttons[output] = this.buttonsVisibility[output] !== undefined ? this.buttonsVisibility[output] : this[output].observers.length > 0;
  }
  
  ngAfterViewInit(): void {
    // this.modal.show(this.dialog, {});
  }

  cancel(){
    this.onCancel.emit();
    this.closeModals();
    //this.modal.dismiss('cancel')
  }

  close(){
    this.onClose.emit();
    this.closeModals();
  }

  confirm(){
    if (this.validate()) {
      this.onConfirm.emit();
      this.closeModals();
    }    
  }

   save(){
    this.onSave.emit();
  }
  
  closeModals(){
  	let modals = this.modal.getModalsCount()
    while(modals > 0){
      this.modal.hide(modals--);
    }
    this.modal.hide();
  }
  //modal.close('Ok click')
  //modal.dismiss('cancel click')
}
